import TemplateSelector from 'components/organisms/TemplateSelector/TemplateSelector';
import React from 'react';

 export default function RoomTemplates () {
    return (
        <div>
            <TemplateSelector />
        </div>
    );
}
